"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var material_1 = require("@mui/material");
var ExpandMore_1 = __importDefault(require("@mui/icons-material/ExpandMore"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var Tab_1 = __importDefault(require("@/Components/common/Tab"));
var AppIntegrationResourceSettings_1 = __importDefault(require("./AppIntegrationResourceSettings"));
var AppIntegrationResourceLogs_1 = __importDefault(require("./AppIntegrationResourceLogs"));
var AppIntegrationResourceStatus_1 = __importDefault(require("./AppIntegrationResourceStatus"));
var AppIntegrations_module_css_1 = __importDefault(require("./AppIntegrations.module.css"));
var AppIntegrationHelper_1 = __importDefault(require("./AppIntegrationHelper"));
var AccessControl_1 = __importDefault(require("../common/AccessControl"));
var PusherService_1 = __importDefault(require("@/functions/PusherService"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var AppIntegrationResourceAccordion = function (props) {
    var _a, _b, _c, _d;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _e = (0, react_1.useState)(undefined), appIntegrationResourceTemplate = _e[0], setAppIntegrationResourceTemplate = _e[1];
    var _f = (0, react_1.useState)(props.appIntegration ? "status" : "settings"), selectedResourceTab = _f[0], setSelectedResourceTab = _f[1];
    var _g = (0, react_1.useState)(undefined), resourceImageUrl = _g[0], setResourceImageUrl = _g[1];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var _h = (0, react_1.useState)(undefined), resourceResult = _h[0], setResourceResult = _h[1];
    var _j = (0, react_1.useState)(undefined), resourceErrorImageUrl = _j[0], setResourceErrorImageUrl = _j[1];
    var _k = (0, react_1.useState)(undefined), integrationJobList = _k[0], setIntegrationJobList = _k[1];
    var _l = (0, react_1.useState)(undefined), latestIntegrationJob = _l[0], setLatestIntegrationJob = _l[1];
    var _m = (0, react_1.useState)(undefined), currentIntegrationJob = _m[0], setCurrentIntegrationJob = _m[1];
    var _o = (0, react_1.useState)(false), hasActiveRequests = _o[0], setHasActiveRequests = _o[1];
    var _p = (0, react_1.useState)({}), jobStates = _p[0], setJobStates = _p[1];
    var _q = (0, react_1.useState)(false), isBusy = _q[0], setBusy = _q[1];
    var integrationResource = (_c = (_b = (_a = props.appIntegration) === null || _a === void 0 ? void 0 : _a.definition) === null || _b === void 0 ? void 0 : _b.resources[props.identifier]) !== null && _c !== void 0 ? _c : undefined;
    var isNew = integrationResource ? false : true;
    var ResourceStatusLabel = function () {
        var statusTxt;
        var color;
        if (!currentIntegrationJob) {
            statusTxt = t("Pending");
            color = "var(--info-color)";
        }
        else {
            switch (currentIntegrationJob.exit_code) {
                case 0:
                    statusTxt = t("Success");
                    color = "var(--primary-color)";
                    break;
                default:
                    statusTxt = t("Failed");
                    color = "var(--error-color)";
                    break;
            }
        }
        return (react_1.default.createElement(material_1.Typography, { sx: {
                fontSize: "0.95rem",
                fontFamily: "Geomanist",
                color: color,
            } }, statusTxt));
    };
    var loadResourceImage = function () { return __awaiter(void 0, void 0, void 0, function () {
        var imageUrl, response, blob, objectUrl, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!props.appIntegration) return [3 /*break*/, 6];
                    imageUrl = "/api/app-integrations/" + props.appIntegration.id + "/image/" + props.identifier;
                    return [4 /*yield*/, fetch(imageUrl)];
                case 1:
                    response = _b.sent();
                    if (!(props.appIntegrationTemplate.type === "webcapture")) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.blob()];
                case 2:
                    blob = _b.sent();
                    objectUrl = URL.createObjectURL(blob);
                    setResourceImageUrl(objectUrl);
                    return [3 /*break*/, 5];
                case 3:
                    _a = setResourceResult;
                    return [4 /*yield*/, response.json()];
                case 4:
                    _a.apply(void 0, [_b.sent()]);
                    _b.label = 5;
                case 5:
                    reloadIntegrationJobs();
                    _b.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var loadResourceErrorImage = function () { return __awaiter(void 0, void 0, void 0, function () {
        var imageUrl, response, blob, objectUrl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(props.appIntegration && currentIntegrationJob)) return [3 /*break*/, 3];
                    imageUrl = "/api/app-integrations/".concat(props.appIntegration.id, "/jobs/").concat(currentIntegrationJob.resource, "/").concat(currentIntegrationJob.id, "/error");
                    return [4 /*yield*/, fetch(imageUrl)];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.blob()];
                case 2:
                    blob = _a.sent();
                    objectUrl = URL.createObjectURL(blob);
                    setResourceErrorImageUrl(objectUrl);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var loadIntegrationJobs = function () { return __awaiter(void 0, void 0, void 0, function () {
        var jobs;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(((_a = props.appIntegration) === null || _a === void 0 ? void 0 : _a.id) && props.identifier)) return [3 /*break*/, 2];
                    return [4 /*yield*/, AppIntegrationHelper_1.default.getIntegrationJobs(props.appIntegration.id, props.identifier)];
                case 1:
                    jobs = _b.sent();
                    setIntegrationJobList(jobs);
                    _b.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var reloadIntegrationJobs = function () {
        loadIntegrationJobs();
    };
    var reloadResourceImage = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, loadResourceImage()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var loadCurrentIntegrationJobDetails = function (job) { return __awaiter(void 0, void 0, void 0, function () {
        var jobDetails;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, AppIntegrationHelper_1.default.getIntegrationJob(job.integration_id, job.resource, job.id)];
                case 1:
                    jobDetails = _a.sent();
                    setCurrentIntegrationJob(jobDetails);
                    return [2 /*return*/];
            }
        });
    }); };
    var loadLatestIntegrationJobDetails = function (job) { return __awaiter(void 0, void 0, void 0, function () {
        var jobDetails;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, AppIntegrationHelper_1.default.getIntegrationJob(job.integration_id, job.resource, job.id)];
                case 1:
                    jobDetails = _a.sent();
                    setLatestIntegrationJob(jobDetails);
                    return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        var _a, _b, _c, _d;
        var timer;
        var clearTimer = function () {
            if (timer) {
                clearTimeout(timer);
                timer = undefined;
            }
        };
        if (props.isActive && !isNew) {
            if (integrationJobList && integrationJobList.length > 0) {
                var hasActiveJob = integrationJobList.some(function (job) { return !job.ended_at; });
                setHasActiveRequests(hasActiveJob);
                if (hasActiveJob) {
                    // Job is running, check again after a short interval
                    if (!isBusy)
                        setBusy(true);
                    timer = setTimeout(function () {
                        reloadIntegrationJobs();
                    }, 5000);
                }
                else {
                    // No active job, schedule next job based on refresh time
                    if (isBusy)
                        setBusy(false);
                    var refresh = (_a = integrationResource === null || integrationResource === void 0 ? void 0 : integrationResource.variables.refresh) !== null && _a !== void 0 ? _a : (_d = (_c = (_b = props.appIntegration) === null || _b === void 0 ? void 0 : _b.definition) === null || _c === void 0 ? void 0 : _c.setup) === null || _d === void 0 ? void 0 : _d.variables.refresh;
                    if (typeof refresh === "string") {
                        refresh = parseInt(refresh);
                    }
                    if (typeof refresh === "number" && refresh > 0) {
                        var lastRunTime = currentIntegrationJob === null || currentIntegrationJob === void 0 ? void 0 : currentIntegrationJob.ended_at;
                        if (lastRunTime) {
                            var timeSinceLastRun = ((new Date()).getTime() - lastRunTime.getTime()) / 1000;
                            var timeToNextRun = Math.max(0, refresh - timeSinceLastRun) * 1000;
                            timer = setTimeout(function () {
                                reloadResourceImage();
                            }, timeToNextRun);
                        }
                        else {
                            // No last run time, schedule immediately
                            timer = setTimeout(function () {
                                reloadResourceImage();
                            }, 0);
                        }
                    }
                }
            }
            else {
                loadIntegrationJobs();
            }
        }
        else {
            clearTimer();
        }
        return function () {
            clearTimer();
        };
    }, [props.isActive, isNew, integrationJobList, currentIntegrationJob, integrationResource === null || integrationResource === void 0 ? void 0 : integrationResource.variables.refresh]);
    (0, react_1.useEffect)(function () {
        if (integrationJobList && integrationJobList.length > 0) {
            // Load details of the latest job
            var latestJob = integrationJobList[0];
            loadLatestIntegrationJobDetails(latestJob);
            // Find the latest finished job
            var latestFinishedJob = integrationJobList.find(function (job) { return job.ended_at; });
            if (latestFinishedJob) {
                loadCurrentIntegrationJobDetails(latestFinishedJob);
            }
            else {
                setCurrentIntegrationJob(undefined);
            }
        }
    }, [integrationJobList]);
    (0, react_1.useEffect)(function () {
        if (currentIntegrationJob && props.isActive) {
            if (currentIntegrationJob.has_failure_result) {
                loadResourceErrorImage();
            }
            else {
                setResourceErrorImageUrl(undefined);
            }
        }
    }, [currentIntegrationJob, props.isActive]);
    (0, react_1.useEffect)(function () {
        var _a;
        if ((_a = props.resourceEditorData) === null || _a === void 0 ? void 0 : _a.template) {
            var resource = props.appIntegrationTemplate.definition.script.resources[props.resourceEditorData.template];
            if (resource) {
                setAppIntegrationResourceTemplate(resource);
            }
            else {
                setAppIntegrationResourceTemplate(undefined);
            }
        }
        else {
            setAppIntegrationResourceTemplate(undefined);
        }
    }, [(_d = props.resourceEditorData) === null || _d === void 0 ? void 0 : _d.template]);
    (0, react_1.useEffect)(function () {
        if (isNew)
            return;
        if (!integrationJobList) {
            loadIntegrationJobs();
        }
        if (props.isActive) {
            if (props.appIntegrationTemplate.type === "webcapture" && !resourceImageUrl) {
                reloadResourceImage();
            }
        }
    }, [isNew, integrationJobList, props.isActive]);
    (0, react_1.useEffect)(function () {
        if (props.appIntegration) {
            PusherService_1.default.bind("integration", props.appIntegration.id, function (data) {
                var _a;
                switch (data.type) {
                    case "job-state":
                        if (((_a = data.message) === null || _a === void 0 ? void 0 : _a.id) && data.message.resource === props.identifier) {
                            if (!jobStates["#" + data.message.id]) {
                                reloadIntegrationJobs();
                            }
                            var tmp = (0, q_play_core_1.cloneImmutableObject)(jobStates);
                            if (data.message.status >= 6) {
                                delete tmp["#" + data.message.id];
                                reloadResourceImage();
                                reloadIntegrationJobs();
                            }
                            else {
                                tmp["#" + data.message.id] = data.message;
                            }
                            setJobStates(tmp);
                        }
                        break;
                }
            });
        }
    }, [props.appIntegration]);
    return (react_1.default.createElement(material_1.Accordion, { expanded: props.expanded, onChange: props.onChange, sx: {
            borderRadius: "10px",
            boxShadow: "\n            1px 1px 1px -1px rgba(0, 0, 0, 0.2),\n            1px 1px 1px 0px rgba(0, 0, 0, 0.1),\n            1px 1px 1px 0px rgba(0, 0, 0, 0.1)",
            width: "100%",
        } },
        react_1.default.createElement(material_1.AccordionSummary, { "data-cy": "integrationResourceAccordionHeader", expandIcon: react_1.default.createElement(ExpandMore_1.default, null), sx: {
                "&.Mui-expanded": {
                    backgroundColor: "var(--secondary-color)",
                    borderRadius: "5px"
                },
                height: "60px",
                backgroundColor: "#f9f8f8"
            } },
            react_1.default.createElement("div", { className: AppIntegrations_module_css_1.default["accordion-summary-container"] },
                react_1.default.createElement("div", { style: { display: "flex", alignItems: "center" } },
                    react_1.default.createElement("div", { style: { color: "var(--info-color)" } }, props.resourceEditorData.name)),
                react_1.default.createElement("div", { style: { display: "flex", alignItems: "center" } },
                    hasActiveRequests ? (react_1.default.createElement("span", { style: { marginRight: "4px" } },
                        react_1.default.createElement(q_play_components_1.Spinner, null))) : (react_1.default.createElement(react_1.default.Fragment, null)),
                    react_1.default.createElement(ResourceStatusLabel, null)))),
        react_1.default.createElement(material_1.AccordionDetails, null,
            !isNew ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { style: { display: "flex", justifyContent: "flex-end", marginTop: "10px" } },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(AccessControl_1.default, { conditionalChildren: [
                                {
                                    permission: props.permissions.manage,
                                    children: (react_1.default.createElement(react_1.default.Fragment, null,
                                        react_1.default.createElement(Tab_1.default, { dataCy: "resourceStatusTabButton", onClick: function () { return setSelectedResourceTab("status"); }, className: AppIntegrations_module_css_1.default["integration-editor-tab"], text: t("Status"), active: selectedResourceTab === "status" }),
                                        react_1.default.createElement(Tab_1.default, { dataCy: "resourceLogsTabButton", onClick: function () { return setSelectedResourceTab("logs"); }, className: AppIntegrations_module_css_1.default["integration-editor-tab"], text: t("Script Logs"), active: selectedResourceTab === "logs" }),
                                        react_1.default.createElement(Tab_1.default, { onClick: function () { return setSelectedResourceTab("settings"); }, className: AppIntegrations_module_css_1.default["integration-editor-tab"], text: t("Settings"), active: selectedResourceTab === "settings", dataCy: "resourceSettingsTabButton" })))
                                },
                                {
                                    permission: __spreadArray(__spreadArray([], props.permissions.read, true), props.permissions.write, true),
                                    children: (react_1.default.createElement(Tab_1.default, { dataCy: "resourceSettingsTabButton", onClick: function () { return setSelectedResourceTab("status"); }, className: AppIntegrations_module_css_1.default["integration-editor-tab"], text: t("Status"), active: true }))
                                }
                            ] })))))
                :
                    react_1.default.createElement(react_1.default.Fragment, null),
            selectedResourceTab === "logs" && !isNew ? (react_1.default.createElement(AppIntegrationResourceLogs_1.default, { identifier: props.identifier, appIntegration: props.appIntegration, resourceErrorImageUrl: resourceErrorImageUrl, currentIntegrationJob: currentIntegrationJob })) : (selectedResourceTab === "settings" || isNew ? (react_1.default.createElement(AppIntegrationResourceSettings_1.default, { identifier: props.identifier, appIntegrationTemplate: props.appIntegrationTemplate, appIntegration: props.appIntegration, appIntegrationResourceTemplate: appIntegrationResourceTemplate, setAppIntegrationResourceTemplate: setAppIntegrationResourceTemplate, resourceEditorData: props.resourceEditorData, onResourceChangedHandler: props.onResourceChangedHandler })) : (react_1.default.createElement(AppIntegrationResourceStatus_1.default, { identifier: props.identifier, appIntegrationTemplate: props.appIntegrationTemplate, appIntegration: props.appIntegration, integrationJobList: integrationJobList, latestIntegrationJob: latestIntegrationJob, resourceImageUrl: resourceImageUrl, resourceResult: resourceResult, reloadResourceImage: reloadResourceImage, jobStates: jobStates }))))));
};
exports.default = AppIntegrationResourceAccordion;
